// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.width-auto{
	width: auto;
}
.dataTables_info{
	padding-top: 0.85rem;
}
.text-error{
	color: #dc3545;
	font-size: 0.8rem;
}
.error-fullname{
	margin-top: -10px;
}
/* #candidateList tr.odd td.dataTables_empty{
	display: none!important;
} */
.text-error{
	font-size: 0.8rem;
}
.white-space-wrap{
	white-space: pre-wrap;
}
.scroll-body-dialog{
	height: 60vh;
	overflow-y: scroll;
}

.pointer {
	cursor: pointer;
}

.text-left{
	text-align: left;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbnRyYWN0LWxpc3QuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtDQUNDLFdBQVc7QUFDWjtBQUNBO0NBQ0Msb0JBQW9CO0FBQ3JCO0FBQ0E7Q0FDQyxjQUFjO0NBQ2QsaUJBQWlCO0FBQ2xCO0FBQ0E7Q0FDQyxpQkFBaUI7QUFDbEI7QUFDQTs7R0FFRztBQUNIO0NBQ0MsaUJBQWlCO0FBQ2xCO0FBQ0E7Q0FDQyxxQkFBcUI7QUFDdEI7QUFDQTtDQUNDLFlBQVk7Q0FDWixrQkFBa0I7QUFDbkI7O0FBRUE7Q0FDQyxlQUFlO0FBQ2hCOztBQUVBO0NBQ0MsZ0JBQWdCO0FBQ2pCIiwiZmlsZSI6ImNvbnRyYWN0LWxpc3QuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi53aWR0aC1hdXRve1xuXHR3aWR0aDogYXV0bztcbn1cbi5kYXRhVGFibGVzX2luZm97XG5cdHBhZGRpbmctdG9wOiAwLjg1cmVtO1xufVxuLnRleHQtZXJyb3J7XG5cdGNvbG9yOiAjZGMzNTQ1O1xuXHRmb250LXNpemU6IDAuOHJlbTtcbn1cbi5lcnJvci1mdWxsbmFtZXtcblx0bWFyZ2luLXRvcDogLTEwcHg7XG59XG4vKiAjY2FuZGlkYXRlTGlzdCB0ci5vZGQgdGQuZGF0YVRhYmxlc19lbXB0eXtcblx0ZGlzcGxheTogbm9uZSFpbXBvcnRhbnQ7XG59ICovXG4udGV4dC1lcnJvcntcblx0Zm9udC1zaXplOiAwLjhyZW07XG59XG4ud2hpdGUtc3BhY2Utd3JhcHtcblx0d2hpdGUtc3BhY2U6IHByZS13cmFwO1xufVxuLnNjcm9sbC1ib2R5LWRpYWxvZ3tcblx0aGVpZ2h0OiA2MHZoO1xuXHRvdmVyZmxvdy15OiBzY3JvbGw7XG59XG5cbi5wb2ludGVyIHtcblx0Y3Vyc29yOiBwb2ludGVyO1xufVxuXG4udGV4dC1sZWZ0e1xuXHR0ZXh0LWFsaWduOiBsZWZ0O1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/all-modules/contracts/contract-list/contract-list.component.css"],"names":[],"mappings":"AAAA;CACC,WAAW;AACZ;AACA;CACC,oBAAoB;AACrB;AACA;CACC,cAAc;CACd,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;;GAEG;AACH;CACC,iBAAiB;AAClB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,orCAAorC","sourcesContent":[".width-auto{\n\twidth: auto;\n}\n.dataTables_info{\n\tpadding-top: 0.85rem;\n}\n.text-error{\n\tcolor: #dc3545;\n\tfont-size: 0.8rem;\n}\n.error-fullname{\n\tmargin-top: -10px;\n}\n/* #candidateList tr.odd td.dataTables_empty{\n\tdisplay: none!important;\n} */\n.text-error{\n\tfont-size: 0.8rem;\n}\n.white-space-wrap{\n\twhite-space: pre-wrap;\n}\n.scroll-body-dialog{\n\theight: 60vh;\n\toverflow-y: scroll;\n}\n\n.pointer {\n\tcursor: pointer;\n}\n\n.text-left{\n\ttext-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
